import Vue from 'vue'
import Router from 'vue-router'
import FirstPage from '../components/firstPage'
import NewsPage from '../components/newsPage'
import FilmgraphyPage from '../components/filmgraphyPage'
import NewsinfoPage from '../components/newsInfoPage.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {path: '/', redirect: '/FirstPage'},
    {
      path: '/FirstPage',
      name: 'FirstPage',
      component: FirstPage
    },
    {
      path: '/NewsPage',
      name: 'NewsPage',
      component: NewsPage,
    },
    {
      path: '/FilmgraphyPage',
      name: 'FilmgraphyPage',
      component: FilmgraphyPage
    },
    {
      path: '/NewsPage/NewsinfoPage',
      name: 'NewsinfoPage',
      component: NewsinfoPage
    },
  ],
  // mode: 'history', //要是设置history模式 后端服务器必须配置参考网址https://router.vuejs.org/guide/essentials/history-mode.html#example-server-configurations
  //设置锚点
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return {x: 0, y: 0}
    }
  },

})



// WEBPACK FOOTER //
// ./src/router/index.js